import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { hasChanges } from '../../common/utils';
import WarehousesApproval from './WarehousesApproval';
import WarehousesForm from './WarehousesForm';
import WarehousesView from './WarehousesView';
import { BlockWrapper } from '../../common/BlockWrapper';
import './Warehouses.scss';
import get from 'lodash/get';

const Warehouses = ({
    port,
    pendingChanges,
    onApproveField,
    onRejectField,
    updatePortField,
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const saveChanges = async (change) => {
        updatePortField('warehouses', change, () => {
            setIsEditing(false);
        });
    };

    const processedStatus = get(pendingChanges, 'processedFields.warehouses.status');

    const isApproved = processedStatus === 'approved';
    const isRejected = processedStatus === 'rejected';

    const hasWarehouseChanges = 
        !isApproved &&
        !isRejected &&
        hasChanges(
            get(pendingChanges, 'originalValues.warehouses'), 
            get(pendingChanges, 'changedValues.warehouses'),
        );

    if (hasWarehouseChanges) {
        return (
            <BlockWrapper title="Warehouses">
                <WarehousesApproval 
                    originalValues={get(pendingChanges, 'originalValues.warehouses')}
                    changedValues={get(pendingChanges, 'changedValues.warehouses')}
                    onApprove={onApproveField}
                    onReject={onRejectField}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper title="Warehouses">
            {isEditing ? (
                <WarehousesForm 
                    initialValues={{ warehouses: port.warehouses }}
                    onSubmit={values => saveChanges(values.warehouses)}
                    onCancel={() => setIsEditing(false)}
                />
            ) : (
                <React.Fragment>
                    <WarehousesView values={port.warehouses} />
                    <div className="edit-actions">
                        <RaisedButton
                            label="Edit Warehouses"
                            onClick={() => setIsEditing(true)}
                            primary
                        />
                    </div>
                </React.Fragment>
            )}
        </BlockWrapper>
    );
};

Warehouses.propTypes = {
    port: PropTypes.shape({
        warehouses: PropTypes.object,
    }).isRequired,
    pendingChanges: PropTypes.shape({
        changedValues: PropTypes.shape({
            warehouses: PropTypes.object,
        }),
    }),
    onApproveField: PropTypes.func.isRequired,
    onRejectField: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired,
};

export default Warehouses;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Warehouses/Warehouses.jsx